export const NOTE_TYPES = {
  medication: "medication",
  script: "script",
} as const;

export const NOTE_TYPES_VALUES = [NOTE_TYPES.medication] as const;
export type NoteType = (typeof NOTE_TYPES)[keyof typeof NOTE_TYPES];
